"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup"));

var styles_1 = require("@material-ui/core/styles");

var useStyles = styles_1.makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(1)
      }
    }
  };
});

var ButtonsGroup = function ButtonsGroup(props) {
  var classes = useStyles();
  var options = props.options,
      selectedId = props.selectedId,
      _onClick = props.onClick;
  return react_1.default.createElement("div", {
    className: classes.root
  }, react_1.default.createElement(ButtonGroup_1.default, {
    color: "primary",
    "aria-label": "outlined primary button group"
  }, options.map(function (o, i) {
    var isSelected = selectedId === o.id;
    var variant = isSelected ? 'contained' : undefined;
    return react_1.default.createElement(Button_1.default, {
      key: i,
      onClick: function onClick() {
        return _onClick(o.id);
      },
      variant: variant
    }, o.name);
  })));
};

exports.default = ButtonsGroup;